/* src/app/reminder/reminder/reminder.component.scss */
body#themeTag :host ::ng-deep .cdk-virtual-scroll-content-wrapper .p-dropdown-item {
  width: fit-content;
}
body#themeTag :host ::ng-deep #dtReminder .p-datatable .p-datatable-thead > tr:nth-child(2) > th {
  position: sticky;
  top: 24px;
  z-index: 99;
  padding: 0.25em !important;
}
body#themeTag :host ::ng-deep #dtReminder .p-datatable .p-datatable-thead > tr:first-child > th {
  padding: 0 0.25em !important;
}
body#themeTag :host ::ng-deep #dtReminder .p-datatable .p-datatable-tbody > .p-datatable-row {
  height: 2.6em;
}
body#themeTag :host ::ng-deep #dtReminder .p-datatable .p-datatable-tbody > .p-datatable-row > .p-datatable-cell {
  vertical-align: middle;
  padding: 0 0.5em;
}
body#themeTag :host ::ng-deep #dtReminder .p-datatable .p-datatable-tbody > .p-datatable-row > .p-datatable-cell div[data-toggle=tooltip] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
body#themeTag :host ::ng-deep #dtReminder .p-datatable .p-datatable-tbody > .p-datatable-row > .p-datatable-cell .btn-link {
  padding: 0;
}
body#themeTag :host ::ng-deep .tickcross.fa-check {
  color: green;
}
body#themeTag :host ::ng-deep .tickcross.fa-times {
  color: maroon;
}
.inputswitch {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-right: 0.5em;
}
.inputswitch > * {
  flex-shrink: 1;
  padding: 0 0.25em;
}
.inputswitch > p-checkbox {
  margin-top: 0.25em;
}
/*# sourceMappingURL=reminder.component.css.map */
